module.exports = __webpack_public_path__ + "media/brands/bmw-b14e88ab.png";